declare global {
  interface Window {
    env?: Record<string, string>;
  }
}

function getEnv(key: string, fallback?: string): string {
  const val = window.env?.[key] ?? process.env[key];
  if (val) return val;
  if (fallback !== undefined) return fallback;
  console.error(`Missing required environment variable: ${key}`);
  return '';
}

export const config = {
  oidc: {
    domain: getEnv('REACT_APP_AUTH0_DOMAIN'),
    clientId: getEnv('REACT_APP_AUTH0_CLIENT_ID'),
    audience: getEnv('REACT_APP_AUTH0_AUDIENCE'),
    organization: getEnv('REACT_APP_AUTH0_ORGANIZATION', ''),
  },
  api: {
    baseUrl: getEnv('REACT_APP_SERVER_URL'),
    mcpBaseUrl: getEnv('REACT_APP_MCP_BASE_URL'),
  },
} as const;
